<template>
        <div class="reg_d2">
			<slot />
		</div>
</template>

<script>
export default {

}
</script>

<style scoped>
.reg_d2{
	width: 90%;
	padding: 33px 0;
	margin: 0 auto;
	box-sizing: border-box;
	border:1px solid #78d1a3;
	background-color: #f6fffb;
}
</style>